var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18 17a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm3-4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm-3-4a1 1 0 0 1 .117 1.993L18 11H6a1 1 0 0 1-.117-1.993L6 9zm3-4a1 1 0 0 1 .117 1.993L21 7H3a1 1 0 0 1-.117-1.993L3 5z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }